import { PartyService } from './../../../../services/api/party/party.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatSort, MatPaginator, MatDialogRef, MatDialog, MatGridList, MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';
import { Router } from '@angular/router';
import { DialogChangeTemplateStatusComponent } from './dialog-change-template-status/dialog-change-template-status.component';
import { DialogDeleteTemplateComponent } from './dialog-delete-template/dialog-delete-template.component';
import { DialogEditTemplateComponent } from './dialog-edit-template/dialog-edit-template.component';
import { TemplatesService } from 'src/app/services/api/templates/templates.service';
import { TemplateData } from 'src/app/models/interface/template/templateData';
import { Mapping } from 'src/app/models/interface/template/mapping';
import { NGXLogger } from 'ngx-logger';
import { NotificationsService, NotificationLevel } from 'src/app/services/api/notifications/notifications.service';

@Component({
  selector: 'app-search-templates',
  templateUrl: './search-templates.component.html',
  styleUrls: ['./search-templates.component.scss']
})
export class SearchTemplatesComponent implements OnInit {

  @ViewChild(MatPaginator, null) paginator: MatPaginator;
  @ViewChild(MatSort, null) sort: MatSort;

  dataSource: MatTableDataSource<TemplateData>;
  displayedColumns = [
    'value',
    'isActive',
    'serviceTemplate',
    'actions'
  ];

  tooltip = {
    refresh: '',
    clear: '',
    edit: '',
    delete: ''
  }

  tiles: any[];

  pendingActions = {
    queryTemplates: false,
    dialogChangeStatus: false
  }

  combos = {
    type: null,
    status: null
  };

  newTemplateIsDisabled: boolean;

  parties: Array<any>;
  form: FormGroup;
  filterValues: any;

  private modelChanged: Subject<string> = new Subject<string>();
  private subscription: Subscription;
  private writingTimeout = 500;

  dialogChangeStatusRef: MatDialogRef<DialogChangeTemplateStatusComponent>;
  dialogDeleteTemplateRef: MatDialogRef<DialogDeleteTemplateComponent>;
  dialogEditTemplateRef: MatDialogRef<DialogEditTemplateComponent>;

  isps: any[];

  constructor(
    private translate: TranslateService,
    private breadcrumbsService: BreadcrumbsService,
    private router: Router,
    private dialog: MatDialog,
    private templatesService: TemplatesService,
    private partyService: PartyService,
    private logger: NGXLogger,
    private notificationsService: NotificationsService
  ) {

  }

  ngOnInit() {
    this.newTemplateIsDisabled = true;
    this.breadcrumbsService.sendBreadcrumbs(
      {
        breadcrumbs:
          [
            { title: 'Administración', url: 'provision/management' },
            { title: 'Templates FTTH', url: 'provision/management/templates/search' }
          ]
      }
    );

    this.form = new FormGroup({});

    const formControl = new FormControl('');
    this.form.addControl('isp', formControl);


    this.filterValues = {};
    this.partyService.getCustomers().subscribe(data =>{
        this.parties = data;
        this.parties.sort(function (a, b) {
          if (a.name === "Cualquiera") return -1;
          if (b.name === "Cualquiera") return 1;
          return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : 0
        });
        this.newTemplateIsDisabled = false;
        this.initForm(data);

        this.paginator.pageIndex = 0;
        this.paginator.pageSize = 10;

        this.sort.active = 'value';
        this.sort.direction = 'desc';

        this.dataSource = new MatTableDataSource();

        this.submitForm();
    })
   
    this.initTooltips();
    this.subscribeToFormChanges();
  }

  inputChanged() {
    this.modelChanged.next();
  }


  private initForm(data: any[]) {

    this.isps = [{ name: 'Cualquiera', value: null }].concat(data);

    this.filterValues['isp'] = this.isps[0].value;


  }

  private initTooltips() {
    this.translate.get('DUMMY.key').subscribe((translated: string) => {
      this.tooltip.refresh = this.translate.instant('TOOLTIPS.refreshResults');
      this.tooltip.clear = this.translate.instant('TOOLTIPS.clearForm');
      this.tooltip.edit = this.translate.instant('TOOLTIPS.editTemplate');
      this.tooltip.delete = this.translate.instant('TOOLTIPS.deleteTemplate');
    });
  }

  private subscribeToFormChanges() {
    this.subscription = this.modelChanged
      .pipe(
        debounceTime(this.writingTimeout),
      ).subscribe((value) => {
        this.submitForm();
      });
  }

  public submitForm(paginate?: boolean) {

    const DATA: TemplateData[] = [];

    this.logger.info('Buscando templates...');

    this.templatesService.getTemplates(
      this.paginator.pageIndex.toString(),
      this.paginator.pageSize.toString(),
      this.sort.active ? this.sort.active + ',' + this.sort.direction : null,
      this.filterValues,
      ""
    ).subscribe((data) => {
      for (const template of data.content) {
        DATA.push({ id: template.id, value: template.value, isActive: template.isActive, 
          serviceTemplate: template.serviceTemplate, mappings: template.mappings });
      }
      this.dataSource.data = DATA;
      this.paginator.length = data.totalElements;
      if (!paginate) {
        this.paginator.firstPage();
      }
    },
      (error) => {
        this.logger.error('Error en búsqueda de templates...');
      });


  }

  public checkButtonStatus(element: TemplateData, target: boolean) {
    return element.isActive === target;
  }

  public openDialogChangeStatus(element: TemplateData) {
    this.pendingActions.dialogChangeStatus = true;
    this.dialogChangeStatusRef = this.dialog.open(DialogChangeTemplateStatusComponent, {
      data: {
        element
      }
    });

    this.dialogChangeStatusRef.afterClosed().subscribe((boolChangeStatus) => {
      if (boolChangeStatus) {
        const mappingData: Mapping[] = [];


        for (const mapping of element.mappings) {
          mappingData.push({
            id: mapping.id,
            territoryOwner: mapping.territoryOwner,
            territoryReseller: mapping.territoryReseller,
            territoryUser: mapping.territoryUser,
            externalTemplateISP: mapping.externalTemplateISP,
            externalTemplateINO: mapping.externalTemplateINO,
            tv: mapping.tv,
          });
        }

        const template = {
          value: element.value,
          isActive: !element.isActive,
          mappings: mappingData,
        };
        const body = {
          id: element.id,
          template
        };

        this.templatesService.changeTemplateState(element.id).subscribe(
          (data) => {
            this.notificationsService.showNotification(`Se ha modificado el estado del Template ${template.value} de forma correcta`, NotificationLevel.SUCCESS);
            this.submitForm();
          },
          (error) => {
            this.notificationsService.showNotification(
              `Ha habido un problema al modificar el estado del template:\n${error.error.errorDesc.message}`,
              NotificationLevel.ERROR);
          });
      }

      this.pendingActions.dialogChangeStatus = false;
    });
  }

  public editTemplate(element: TemplateData) {
    this.dialogEditTemplateRef = this.dialog.open(DialogEditTemplateComponent, {
      data: {
        isps: this.isps,
        element
      }
    });

    this.dialogEditTemplateRef.afterClosed().subscribe(() => {
      this.submitForm();
    });
  }

  public deleteTemplate(element: TemplateData) {
    this.dialogDeleteTemplateRef = this.dialog.open(DialogDeleteTemplateComponent, {
      data: {
        element
      }
    });

    this.dialogDeleteTemplateRef.afterClosed().subscribe((boolDeleteTemplate) => {
      if (boolDeleteTemplate) {
        this.templatesService.deleteTemplate(element.id).subscribe(
          (data) => {
            this.notificationsService.showNotification(`Template ${element.value} borrada correctamente`, NotificationLevel.SUCCESS);
            this.submitForm();
          },
          (error) => {
            this.notificationsService.showNotification(
              `Ha habido un problema al borrar el template:\n${error.error.errorDesc.message}`, NotificationLevel.ERROR);
          }
        );
      }
    });
  }

  public goToNewTemplate() {
    this.router.navigate([`/provision/management/templates/new`, {  }]);
  }

  public clearForm() {
    this.form.reset();
  }

  public clearAndQueryForm() {
    this.clearForm();
    this.submitForm();
  }

}
